import React from 'react';
import { useTranslation } from 'react-i18next';
import { NavBar } from '../../../components/essentials/navbar/navbar.component';
import { Footer } from '../../../components/essentials/footer/footer.component';
import { Getstarted } from '../../../components/essentials/get-started/getstarted.component';

import phoneImg from '../../../assest/25 - Age Verification/Transparent Cropped phone.png';
import kysBulletPoint from '../../../assest/2 - Solutions - Platforms/secure-payment.svg';
import photoOnPhone from '../../../assest/25 - Age Verification/How it works white.png';
import benefits from '../../../assest/25 - Age Verification/Benefits (2).png';
import './age-verification.scss';
import { OverlapBoxFeature } from '../features-page/features-page.component';

import tobacco from '../../../assest/25 - Age Verification/icons/tobacco.png';
import gamble from '../../../assest/25 - Age Verification/icons/gaming.png';
import alcohol from '../../../assest/25 - Age Verification/icons/alcohol.png';
import cbd from '../../../assest/25 - Age Verification/icons/cbd.png';
import content from '../../../assest/25 - Age Verification/icons/content.png';
import pharma from '../../../assest/25 - Age Verification/icons/pharma.png';
import diy from '../../../assest/25 - Age Verification/icons/diy.png';
import weapon from '../../../assest/25 - Age Verification/icons/weapons.png';

import complaint from '../../../assest/25 - Age Verification/icons/compliant.png';
import privacy from '../../../assest/25 - Age Verification/icons/privacy preserving.png';
import seamless from '../../../assest/25 - Age Verification/icons/seamless integration.png';
import global from '../../../assest/25 - Age Verification/global coverage.png';
import dataAnalytics from '../../../assest/25 - Age Verification/9624 man.png';
import TrackedSection from '../../../components/essentials/google/GoogleAnalytics';

export const AgeVerification = () => {
  const { t } = useTranslation('age-verification');

  return (
    <div className='blogs-main'>
      <NavBar />
      <HeaderHalf title={t('pageTitle')} uris={t('pageUri')} />

      <OverlapBoxTechno img={phoneImg} title={t('technoTitle')}>
        <TrackedSection sectionName="AgeVerificationPage IntroSection">
          <p>{t('introParagraph1')}</p>
          <p>{t('introParagraph2')}</p>
          <p>{t('introParagraph3')}</p>
        </TrackedSection>
      </OverlapBoxTechno>

      <OverlapBoxFeature title={t('howItWorksTitle')}>
        <TrackedSection sectionName="AgeVerificationPage SolutionWorks">
          <MoreBox />
        </TrackedSection>
      </OverlapBoxFeature>

      <OverlapBoxIndustry title={t('industryUseCasesTitle')} className=' overlap-box-industry'>
        <TrackedSection sectionName="AgeVerificationPage Industry">
          <p className='industries-text'>{t('industryIntro')}</p>
          <div className='cards-div-industries'>
            <LargeCard img={tobacco} title={t('tobaccoTitle')} desc={t('tobaccoDesc')} />
            <LargeCard img={gamble} title={t('gambleTitle')} desc={t('gambleDesc')} />
            <LargeCard img={alcohol} title={t('alcoholTitle')} desc={t('alcoholDesc')} />
            <LargeCard img={cbd} title={t('cbdTitle')} desc={t('cbdDesc')} />
            <LargeCard img={content} title={t('contentTitle')} desc={t('contentDesc')} />
            <LargeCard img={pharma} title={t('pharmaTitle')} desc={t('pharmaDesc')} />
            <LargeCard img={diy} title={t('diyTitle')} desc={t('diyDesc')} />
            <LargeCard img={weapon} title={t('weaponTitle')} desc={t('weaponDesc')} />
          </div>
        </TrackedSection>
      </OverlapBoxIndustry>

      <OverlapBoxFeature title={t('solutionBenefitsTitle')}>
        <TrackedSection sectionName="AgeVerificationPage SolutionBenefits">
          <EarthidBox />
        </TrackedSection>
      </OverlapBoxFeature>

      <OverlapBoxFeature title={t('trustSectionTitle')}>
        <TrackedSection sectionName="AgeVerificationPage Trust">
          <div className='platform-content'>
            <p className='cards-div-title'>{t('trustIntro')}</p>
            <div className='cards-div-platform'>
              <MediumCard icon={complaint} title={t('compliantTitle')} desc={t('compliantDesc')} />
              <MediumCard icon={privacy} title={t('privacyTitle')} desc={t('privacyDesc')} />
              <MediumCard icon={seamless} title={t('seamlessTitle')} desc={t('seamlessDesc')} />
            </div>
          </div>
        </TrackedSection>
      </OverlapBoxFeature>

      <SectionRight
        title={t('globalCoverageTitle')}
        title1={t('globalCoverageTitle1')}
        content1={t('globalCoverageContent1')}
        title2={t('globalCoverageTitle2')}
        content2={t('globalCoverageContent2')}
        imgPath={global}
      />

      <SectionLeft
        title={t('securityTitle')}
        title1={t('securityTitle1')}
        content1={t('securityContent1')}
        title2={t('securityTitle2')}
        content2={t('securityContent2')}
        imgPath={dataAnalytics}
      />

      <Getstarted />
      <Footer />
    </div>
  );
};



const HeaderHalf = ({ title, uris }) => {
  return (
    <div className='headerHalf-main-distributeav'>
      <div className='headerHalf-content'>
        <p className='headerHalf-title'>{title}</p>
        <p className='headerHalf-uris'>
        Solutions / <span className='uris-class'>{uris}</span>
        </p>
      </div>
    </div>
  );
};


  const OverlapBoxIndustry = props => {
    return (
      <div className='overlap-boxx'>
        <p className='box-title'>{props.title}</p>
        {props.children}
      </div>
    );
  };

  const LargeCard = ({ img, desc, title }) => {
    return (
      <div className='large-card'>
        <img src={img} className='large-card-img' alt='largeCardImg' />
        <p className='large-card-title'>{title}</p>
        <p className='large-card-desc'>{!desc ? 'right now description is not available' : desc}</p>
      </div>
    );
  };

  const MoreBox = () => {
    const { t } = useTranslation('age-verification');
  
    return (
      <div className='kys-div'>
        <div className='kys-platform-content'>
          {[1, 2, 3].map(i => (
            <KYSCard
              key={i}
              icon={kysBulletPoint}
              title={t(`moreBox.card${i}.title`)}
              desc={t(`moreBox.card${i}.desc`)}
            />
          ))}
        </div>
        <div className='kys-platform-content'>
          {[4, 5, 6].map(i => (
            <KYSCard
              key={i}
              icon={kysBulletPoint}
              title={t(`moreBox.card${i}.title`)}
              desc={t(`moreBox.card${i}.desc`)}
            />
          ))}
        </div>
        <div className='kys-platform-img'>
          <img src={photoOnPhone} className='kys-platform-imagee' alt='MoreCardIcon' />
        </div>
      </div>
    );
  };
  
  const EarthidBox = () => {
    const { t } = useTranslation('age-verification');
  
    return (
      <div className='kys-div'>
        <div className='kys-platform-content'>
          {[1, 2, 3, 4].map(i => (
            <KYSCard
              key={i}
              icon={kysBulletPoint}
              title={t(`earthidBox.card${i}.title`)}
              desc={t(`earthidBox.card${i}.desc`)}
            />
          ))}
        </div>
        <div className='kys-platform-content'>
          {[5, 6, 7, 8].map(i => (
            <KYSCard
              key={i}
              icon={kysBulletPoint}
              title={t(`earthidBox.card${i}.title`)}
              desc={t(`earthidBox.card${i}.desc`)}
            />
          ))}
        </div>
        <div className='kys-platform-img'>
          <img src={benefits} className='kys-platform-imagee' alt='kysCardIcon' />
        </div>
      </div>
    );
  };


  const SectionRight = props => {
    return (
      <div className='feature-box-right'>
        <p className='title-feature'>{props.title}</p>
        <div className="display-flex">
          <div className='feature-box-content'>
            <div className='overallcontent'>
            <p className='title1-feature'>{props.title1}</p>
          <p className='content1-feature'>{props.content1}</p>
          <p className='title1-feature'>{props.title2}</p>
          <p className='content1-feature'>{props.content2}</p>
            </div>
          
          </div>
          <div className='feature-box-image'>
            <img src={props.imgPath} />
  
          </div>
        </div>
      </div>
    );
  };

  const SectionLeft = props => {
    return (
      <div className='feature-box-left'>
        <p className='title-feature'>{props.title}</p>
        <div className="display-flex">
        <div className='feature-box-image'>
            <img src={props.imgPath} />
  
          </div>
          <div className='feature-box-content'>
            <div className='overallcontent'>
            <p className='title1-feature'>{props.title1}</p>
          <p className='content1-feature'>{props.content1}</p>
          <p className='title1-feature'>{props.title2}</p>
          <p className='content1-feature'>{props.content2}</p>
            </div>
          
          </div>
          
        </div>
      </div>
    );
  };

 const KYSCard = ({ icon, desc, title }) => {
    return (
      <div className='kpl-card'>
        <div className="key-icon-col"><img src={icon} className='kys-card-icon' alt='kysCardIcon' /></div>
        <div className="key-text-col">
          <p className='kys-card-title'>{title}</p>
          <p className='kpl-card-desc'>{!desc ? 'right now description is not available' : desc}</p>
        </div>
      </div>
    );
  };

 const OverlapBoxTechno = ({ img, title, children }) => {
    return (
      <div className='overlap-box-technoo'>
        <img src={img} alt='phone-img' className='techno-img' />
        <div className='techno-content'>
          <p className='techno-title'>{title}</p>
          <div className='rest-para'>{children}</div>
        </div>
      </div>
    );
  };


  const MediumCard = ({ icon, desc, title }) => {
    return (
      <div className='medium-card'>
        <img src={icon} className='medium-card-icon-platform' alt='mediumCardIcon' />
        <p className='medium-card-title'>{title}</p>
        <p className='medium-card-desc-platform'>{!desc ? 'right now description is not available' : desc}</p>
      </div>
    );
  };